<template>
  <!-- Convert button -->
  <div class="basis-full w-full min-w-0 p-0">
    <button
        id="convertBtn"
        type="button"
        :disabled="isPending  || !isHavingFile"
        class="  hover:animate-pulse hover:animate-once relative w-full overflow-hidden btn-base   disabled:translate-y-0 disabled:shadow-sm disabled:text-gray-900 disabled:bg-gray-100"
        :class="{
          'cursor-not-allowed':  isPending,
          'opacity-50 duration-500': !isReadyToConvert,

          'btn-mesh opacity-100 duration-500 animate-pulse animate-infinite animate-delay-[2000ms] animate-ease-in border-2  hover:animate-none ':
           (!isHavingGriffschriftResult || isConversionStale) && isReadyToConvert,
           'btn-primary':  isHavingGriffschriftResult && !isConversionStale && isReadyToConvert,

          ' hover:bg-orange-700': isInputNotMappable,
          'hover:bg-blue-700': !isInputNotMappable && isHavingGriffschriftResult ,
        }"
        @click="handleClick"
    >

      <div class="pointer-events-none absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/10 to-transparent group-hover:animate-[shimmer_1.5s_infinite]"/>

      <div class="relative z-10 flex items-center gap-3">
        <Icon v-if="isPending" icon="fa6-solid:circle-notch" class="shrink-0 animate-spin text-lg "/>

        <Icon v-else-if="isInputNotMappable" icon="fa6-solid:triangle-exclamation" class="shrink-0 text-lg"/>
        <Icon v-else icon="fa6-solid:wand-magic-sparkles" class="shrink-0 text-lg transition-transform group-hover:rotate-12"/>

        <div class="min-w-0" v-if="isPending">
          <div class="text-lg font-semibold animate-rotate-x animate-once">Bitte warten</div>
          <div class="text-sm text-purple-800/80">
            {{ statusText }}
          </div>
        </div>

        <div class="min-w-0 animate-wiggle animate-once" v-else-if="isInputNotMappable">
          <div class="font-semibold">Zur Transposition</div>
          <div class="text-sm text-white/80">Die aktuelle Datei ist so nicht spielbar.</div>
        </div>

        <div class="min-w-0" v-else-if="isConversionStale">
          <div class="font-semibold">Erneut in Griffschrift konvertieren</div>
          <div class="break-words whitespace-normal text-sm text-white/80 disabled:text-current">Die Eingabe hat sich geändert</div>
        </div>

        <div class="min-w-0" v-else>
          <div class="font-semibold">In Griffschrift konvertieren</div>
          <div class="break-words whitespace-normal text-sm text-white/80 disabled:text-current">Eingabe analysieren und Ausgabe erzeugen</div>
        </div>

      </div>
    </button>
  </div>
</template>

<script setup lang="ts">
import {storeToRefs} from 'pinia';
import {Icon} from '@iconify/vue';
import {useSettingsStore} from '@/stores/settings.ts';
import {useMusicUploadStore} from '@/stores/useMusicUploadStore.ts';
import {useMeasureSelectionStore} from '@/stores/useMeasureSelectionStore.ts';
import {ConversionMode} from '@/generated';
import {computed} from "vue";

const settingsStore = useSettingsStore();
const uploadStore = useMusicUploadStore();
const measureSelectionStore = useMeasureSelectionStore();

const {
  isDetectingChords,
  isReadyToConvert,
  isUploading,
  isConverting,
  isHavingFile,
  isPending,
  isMerging,
  isShifting,
  isTransposing,
  isAnalyzing,
  isHavingGriffschriftResult,
  isConversionStale,
  analysisResult,
  isInputNotMappable,
  isBuildingBassPreview,
} = storeToRefs(uploadStore);

const statusText = computed(() => {
  if (isUploading.value)
    return "Datei wird hochgeladen";
  if (isConverting.value)
    return "Griffschrift wird erzeugt";
  if (isAnalyzing.value)
    return "Eingabe wird analysiert";
  if (isMerging.value)
    return "Teile werden zusammengeführt";
  if (isShifting.value)
    return "Griffschrift wird verschoben";
  if (isTransposing.value)
    return "Input wird transponiert"
  if (isDetectingChords.value)
    return "Akkorderkennung läuft"
  if (isBuildingBassPreview.value)
    return "Bass-System wird erzeugt"
  if (isPending.value)
    return "Verarbeitung läuft";

});


function scrollToTranspositionPanel() {
  document.getElementById('transposition-panel')?.scrollIntoView({behavior: 'smooth', block: 'start'});
}

function handleClick() {
  if (analysisResult?.value?.unmappable_count && analysisResult.value.unmappable_count > 8) {
    scrollToTranspositionPanel();
    return;
  }
  if (settingsStore.mode === 'per_measure') {
    measureSelectionStore.loadVariants();
    return;
  }
  uploadStore.startConversion();
}
</script>

<style>
</style>
